import { createAction, createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { API } from '../../constants';
import { application } from '../../services/application';

export const INITIAL_STATE = {
  populated: false,
  activeCategoryId: null,
  loading: false,
  refreshing: false,
  error: null,
  lastFetchPreferSnapshot: true,
  orgId: null,
  categories: {
    federal_opportunities: { status: 'empty', reason: null, items: [] },
    sled_opportunities: { status: 'empty', reason: null, items: [] },
    sled_forecasts: { status: 'empty', reason: null, items: [] },
    vendors: { status: 'empty', reason: null, items: [] },
  },
  hasNaics: true,
  servedStale: false,
  limitReached: false,
  lastRefreshedAt: null,
  fromSnapshot: false,
};

export const setActiveCategory = createAction('dashboardRecommendationsQuickPick/setActiveCategory');

export const fetchDashboardRecommendationsQuickPick = createAsyncThunk(
  'dashboardRecommendationsQuickPick/fetch',
  async (params, { rejectWithValue }) => {
    try {
      const { refresh, activeCategoryId, ...apiParams } = params || {};
      return await application.call(API.RECOMMENDATIONS.GET, apiParams);
    } catch (error) {
      return rejectWithValue(error?.message || 'Failed to load recommendations');
    }
  }
);

function applyPayload(state, action) {
  const payload = action.payload || {};
  state.loading = false;
  state.refreshing = false;
  state.error = null;
  state.populated = true;
  state.orgId = payload.org_id || null;
  state.categories = payload.categories
    ? { ...INITIAL_STATE.categories, ...payload.categories }
    : { ...INITIAL_STATE.categories };

  const profileStatus = payload.profileStatus;
  if (profileStatus) {
    state.hasNaics = Boolean(profileStatus.hasNaics);
  } else {
    state.hasNaics = true;
  }

  const meta = payload.meta || {};
  state.servedStale = Boolean(meta.servedStale);
  state.limitReached = Boolean(meta.limitReached);
  state.lastRefreshedAt = meta.fetchedAt || null;
  state.fromSnapshot = Boolean(meta.fromSnapshot);
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(setActiveCategory, (state, action) => {
      state.activeCategoryId = action.payload || state.activeCategoryId;
    })
    .addCase(fetchDashboardRecommendationsQuickPick.pending, (state, action) => {
      const isRefresh = Boolean(action.meta?.arg?.refresh);
      state.loading = !isRefresh;
      state.refreshing = isRefresh;
      state.error = null;
      state.lastFetchPreferSnapshot = Boolean(action.meta?.arg?.preferSnapshot);
      if (action.meta?.arg?.activeCategoryId) {
        state.activeCategoryId = action.meta.arg.activeCategoryId;
      }
      if (!isRefresh) {
        state.populated = true;
      }
    })
    .addCase(fetchDashboardRecommendationsQuickPick.fulfilled, applyPayload)
    .addCase(fetchDashboardRecommendationsQuickPick.rejected, (state, action) => {
      state.loading = false;
      state.refreshing = false;
      state.error = action.payload || action.error?.message || 'Failed to load recommendations';
      state.populated = true;
    });
});
